// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"9694d4c9","787":"d5fa4d18"}[chunkId] + ".chunk.js";
};